import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import {
    ContactSupportDialogSectionType,
    ContactSupportOptionType,
} from '@fi-shared/fi-support/fi-contact-support-dialog/fi-contact-support-dialog.component';
import { FiContactSupportSectionBase } from '@fi-shared/fi-support/fi-contact-support-dialog/fi-contact-support-section-base';
import { ISectionCardData } from '@fi-shared/fi-section-card/fi-section-card';

@Component({
    selector: 'fi-contact-support-contact-method-section',
    template: `
        <div class="section-header">
          <fi-contact-support-section-header
            [sectionHeaderText]="'support.contact_section_header' | fiAppText"
            (onCloseDialog)="closeDialog()"
            (onGoBack)="goBack()"
            [isBackButtonShown]="true"
            >
          </fi-contact-support-section-header>
        </div>
        
        <p class="section-description">{{ 'support.contact_section_description' | fiAppText }}</p>
        
        <div class="section-content-container">
          @for (availableContactOption of availableContactOptions; track availableContactOption) {
            <fi-section-card
              class="cursor-pointer"
              [contentCardData]="availableContactOption"
              >
            </fi-section-card>
          }
        </div>
        `,
    styleUrls: ['./fi-contact-support-contact-method-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-contact-support-contact-method-section' },
    standalone: false,
})
export class FiContactSupportContactMethodSectionComponent extends FiContactSupportSectionBase {
    availableContactOptions: ISectionCardData[] = [
        {
            headerTextLabel: this.appTextService.get('support.option_chat_header'),
            subheaderTextLabel: this.appTextService.get('support.option_chat_description'),
            id: ContactSupportOptionType.ChatContact,
            onClick: () => {
                this.openChatConversation.emit();
            },
            prefixIconClass: 'far fa-comments',
        },
        {
            headerTextLabel: this.appTextService.get('support.option_email_header'),
            subheaderTextLabel: this.appTextService.get('support.option_email_description'),
            id: ContactSupportOptionType.EmailContact,
            onClick: () => {
                this.setCurrentSupportSectionType(ContactSupportDialogSectionType.Email);
                this.setCurrentSupportOptionType(ContactSupportOptionType.EmailContact);
            },
            prefixIconClass: 'fas fa-envelope-open-text',
        },
    ];
}
